import { createAction } from "typesafe-actions";

import type {
    ContextualSuggestionsData,
    FiltersStateDataWithoutSignals,
} from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/lead-generator/types/content";
import { createActionNamespace } from "app/pages/sales-intelligence/store/utils";

import type { PocessedMessageData } from "./types";

const actionNamespace = createActionNamespace("si/ai-agent/lead-generator");

export const setContextualSuggestions = createAction(
    actionNamespace("set-contextual-suggestions"),
)<ContextualSuggestionsData>();

export const setOutputFilters = createAction(
    actionNamespace("set-output-filters"),
)<FiltersStateDataWithoutSignals | null>();

export const setPreprocessedMessageData = createAction(
    actionNamespace("set-processed-message-data"),
)<PocessedMessageData>();

export const incrementGeneratedQueries = createAction(actionNamespace("increment-generated-queries"))<void>();

export const resetGeneratedQueries = createAction(actionNamespace("reset-generated-queries"))();
